import { get } from 'lodash';

export const getCollaborationsFromProject = (project) =>
  get(project, 'collaborations.edges', []).map((edge) => edge.node);

export const getCollaboratorsFromData = (data) =>
  getCollaborationsFromProject(get(data, 'viewer.project', {}));

export const getProjectOwnerFromData = (data) =>
  get(data, 'viewer.project.owningCollaborator', {});

export const getCollaborationsFromData = (data) =>
  data?.viewer?.project?.collaborations?.edges?.map((edge) => edge.node) ?? [];

export const getCurrentCompanyIdFromData = (data) =>
  data?.viewer?.company?.id ?? '';

export const getHistoricalCollaborationsFromData = (data) =>
  data?.viewer?.project?.historicalCollaborations.map((node) => node) ?? [];
